import { NgModule }       from '@angular/core';
import {CommonModule} from '@angular/common'
import { FormsModule } from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {SampleComponent} from "./sample.component";
import {SampleRoutingModule} from "./sample-routing.module";

@NgModule({
    imports: [CommonModule, FormsModule, SampleRoutingModule, TranslateModule],
    declarations: [
        SampleComponent,
    ]
})
export class Sample2Module {}


// WEBPACK FOOTER //
// ./public/upgrade/feature/sample-v2/sample.module.ts